import { render, staticRenderFns } from "./dashboardTijianjigourenshu.vue?vue&type=template&id=0ec51ec5&scoped=true"
import script from "./dashboardTijianjigourenshu.vue?vue&type=script&lang=js"
export * from "./dashboardTijianjigourenshu.vue?vue&type=script&lang=js"
import style0 from "./dashboardTijianjigourenshu.vue?vue&type=style&index=0&id=0ec51ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec51ec5",
  null
  
)

export default component.exports